const mutations = {
  SET_SMART_SUMMARY(state, smartSummary) {
    state.smartSummary = smartSummary
  },

  SET_SMART_SUMMARY_LIKE(state, like_state) {
    state.smartSummary.is_liked = like_state
  },

  SET_REFUSAL_REASONS(state, refusalReasons) {
    state.refusalReasons = refusalReasons
  },

  SET_CSAT(state, csat) {
    state.csat = csat
  },

  SET_TOP_TERMS(state, topTerms) {
    state.topTerms = topTerms
  },

  SET_TRENDS_TERMS(state, trendsTerms) {
    state.trendsTerms = trendsTerms
  },

  SET_FEELINGS(state, feelings) {
    state.feelings = feelings
  },

  SET_CONVERSATION_AVERAGES(state, conversationAverages) {
    state.conversationAverages = conversationAverages
  },

  SET_FILTER_TAGS(state, filterTags) {
    state.filterTags = filterTags
  },

  SET_IS_FETCHING_SMART_SUMMARY(state, isFetchingSmartSummary) {
    state.isFetchingSmartSummary = isFetchingSmartSummary
  }
}

export default mutations
